import React from 'react';
import { CtaButton } from './CtaButton';
import { ACTIVITIES_LABEL, COLLECTIONS_CLOSING, COLLECTIONS_CTA, COLLECTIONS_SUB, COLLECTIONS_TITLE, GAMES_LABEL, activityCollections, gameCollections } from '../data/halloweenKit';
import type { Collection } from '../data/halloweenKit';
export function CollectionsSection() {
  return <section className="w-full bg-night-950 py-14 sm:py-20" aria-labelledby="collections-title" data-id="element-33" data-mp="3c267p3p1ora7">
      <div className="mx-auto max-w-6xl px-5" data-id="element-34" data-mp="374mso1kiwah7">
        <h2 id="collections-title" className="text-center font-display text-[1.75rem] font-semibold leading-tight text-cream-50 sm:text-[2.6rem]" data-id="element-35" data-mp="323qr3unn90ey">
          {COLLECTIONS_TITLE}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-body sm:text-[16px]" data-id="element-36" data-mp="2t4ltcqjwpb3u">
          {COLLECTIONS_SUB}
        </p>

        <CollectionGroup title={GAMES_LABEL} items={gameCollections} columns="sm:grid-cols-2 lg:grid-cols-3" data-id="element-37" data-mp="w8xr4dp9908b" />
        <CollectionGroup title={ACTIVITIES_LABEL} items={activityCollections} columns="grid-cols-2 lg:grid-cols-4" data-id="element-38" data-mp="3rs8iokyzof3z" />

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-lg italic leading-snug text-cream-100 sm:text-xl" data-id="element-39" data-mp="mgw1vkf7klx">
          {COLLECTIONS_CLOSING}
        </p>
        <div className="mt-7 flex justify-center" data-id="element-40" data-mp="3itwragqatdah">
          <CtaButton size="md" label={COLLECTIONS_CTA} data-id="element-41" data-mp="3nrg7vnagy25l" />
        </div>
      </div>
    </section>;
}
type CollectionGroupProps = {
  title: string;
  items: Collection[];
  columns: string;
};
function CollectionGroup({
  title,
  items,
  columns
}: CollectionGroupProps) {
  return <div className="mt-10" data-id="element-42" data-mp="5lk29jc4zwvh">
      <h3 className="flex items-center gap-4 text-[11px] font-bold uppercase tracking-[0.22em] text-cream-200 sm:text-[12px]" data-id="element-43" data-mp="5k8y3ies4n3u">
        {title}
        <span className="h-px flex-1 bg-night-600" aria-hidden="true" data-id="element-44" data-mp="y9plu2rgfftq" />
      </h3>
      <ul className={`mt-4 grid gap-3 ${columns}`} data-id="element-45" data-mp="y7mlaosoe4ar">
        {items.map(c => <li key={c.name} className="flex flex-col rounded-2xl border border-night-600 bg-night-900 p-4 sm:p-5" data-id="element-46" data-mp="131z6b39svnom">
            <h4 className="text-[12px] font-bold uppercase leading-snug tracking-[0.14em] text-pumpkin sm:text-[13px]" data-id="element-47" data-mp="1cubujicqbvuc">
              {c.name}
            </h4>
            <p className="mt-2 text-[14.5px] font-semibold leading-snug text-cream-50 sm:text-[15px]" data-id="element-48" data-mp="12x78diivw0dj">{c.count}</p>
            {c.description && <p className="mt-1 text-[14px] leading-snug text-body" data-id="element-49" data-mp="xyvtuuhn91oz">{c.description}</p>}
          </li>)}
      </ul>
    </div>;
}